/**
 * Created by rickborst on 18/07/2017.
 */

import {getInstance as getDataSources} from 'datasources';
import {hashHistory} from 'react-router';
import {
    hideModal,
    setStatus as setModalStatus,
    ModalStatus
} from 'store/actions/modal';

const ActionTypes = {
        SET_RESET_PASSWORD_STATUS: 'SET_RESET_PASSWORD_STATUS',
        SET_RESET_PASSWORD_ERROR: 'SET_RESET_PASSWORD_ERROR'
    },

    ResetPasswordStates = {
        INITIAL: 'INITIAL',
        REQUESTING_RESET: 'REQUESTING_RESET',
        REQUEST_FAILED: 'REQUEST_FAILED',
        REQUEST_SUCCESS: 'REQUEST_SUCCESS'
    };

/**
 * Sets the modal status.
 *
 * @param {string} status - Modal status.
 * @returns {Object} Action object.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_RESET_PASSWORD_STATUS,
        status: status
    };
}

/**
 * Sets the modal error.
 *
 * @param {string|null} error - Error or null.
 * @returns {Object} Action object.
 */
function setSubmitError (error) {

    return {
        type: ActionTypes.SET_RESET_PASSWORD_ERROR,
        error: error
    };
}

/**
 * Sets a new password for the current user,
 * using a token send through email.
 *
 * @param {string} token - Token received per email.
 * @param {string} password - New password entered by user.
 * @returns {Function} Function that returns a promise
 * resolving to set password response.
 */
function setPasswordWithToken (token, password) {

    return dispatch => {
        let dataSources = getDataSources();

        dispatch(setModalStatus(ModalStatus.LOADING));

        dataSources.setPasswordWithToken(token, password)
            .then(() => {
                dispatch(setSubmitError(null));
                dispatch(setStatus(ResetPasswordStates.REQUEST_SUCCESS));
                dispatch(setModalStatus(ModalStatus.HIDE));
                dispatch(hideModal());
                hashHistory.push('/login');
				console.trace("hashHistory.push", "setPasswordWithToken");
            })
            .catch((response) => {
                let error = response.result.error;

                if (error && (typeof error === 'string' || error.message)) {

                    error = typeof error === 'string'
                        ? error
                        : error.message;
                } else {

                    error = 'Unknown Error';
                }

                dispatch(setSubmitError(error));
                dispatch(setStatus(ResetPasswordStates.REQUEST_FAILED));
                dispatch(setModalStatus(ModalStatus.SHOW));
            });
    };
}

export {
    setStatus,
    setSubmitError,
    setPasswordWithToken,
    ActionTypes,
    ResetPasswordStates
};


// WEBPACK FOOTER //
// ./src/js/store/actions/modals/resetpassword.js